<template>
  <div class="newsletter">
    <p>{{ $t('components.newsletter.text-1') }}</p>
    <p class="error" v-if="error.isShown">{{ error.text }}</p>
    <form class="stay-informed">
      <div class="input-form">
        <input
          class="email-input"
          v-model="email"
          type="email"
          v-if="!isSubmitted"
          :placeholder="$t('components.newsletter.e-mail')"></input>
        <button
          type="submit"
          v-on:click.prevent="submitNewsletterSignup"
          :disabled="isLoading || isSubmitted"
          >
          <span v-if="!isLoading && !isSubmitted">{{ $t('pages.thanks.sign-up-now') }}</span>
          <span v-if="isLoading" class="loading">{{ $t('loading') }}<span>.</span><span>.</span><span>.</span></span>
          <span v-if="isSubmitted">{{ $t('components.newsletter.thanks') }}</span>
        </button>
      </div>
      <p class="privacy-policy">{{ $t('pages.recurring-signup.privacy-policy-text') }} <router-link :to="{ name: 'privacy' }">{{ $t('pages.recurring-signup.privacy-policy') }}</router-link>.</p>
    </form>
  </div>
</template>

<script>
import { toUrlEncoded } from '@/helperfunctions'

export default {
  name: 'SectionNewsletter',
  data () {
    return {
      email: '',
      isLoading: false,
      isSubmitted: false,
      error: {
        text: '',
        isShown: false,
      }
    }
  },
  methods: {
    submitNewsletterSignup () {
      this.error.text = ''
      this.error.isShown = false

      let newsletterPostUrl = 'https://lists.akvorrat.at/subscribe/newsletter-en'
      if (this.$route.params.lang === 'de') {
        newsletterPostUrl = 'https://lists.akvorrat.at/subscribe/vds-info'
      }

      this.isLoading = true

      fetch(newsletterPostUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: toUrlEncoded({
          email: this.email
        }),
        mode: 'no-cors',
      })
        .then(response => {
          // doesn't work cause CORS stuff
          if (!response.ok) {
            throw Error(response.statusCode)
          }

          this.email = ''
          this.isLoading = false
          this.isSubmitted = true
        })
        .catch(error => {
          this.error.text = error.message
          this.error.isShown = true
          this.isLoading = false

          // so we pretend to have a success case here
          if (!this.error.text) {
            this.email = ''
            this.isSubmitted = true
          }
        })
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang=scss scoped>
@import '@/assets/styles/_variable.scss';

.newsletter {
  background-color: $dark-text-color;
  color: $main-bg;
  width: 100%;
  max-width: 768px;
  padding: 0.5em 1em;
  margin: 0.5em 0;

  h2 {
    color: $main-bg;
  }
  p {
    margin: 0;
  }
  form.stay-informed {
    display: flex;
    flex-direction: column;
    .input-form {
      display: flex;
      align-items: stretch;
      font-size: 1.3em;
      @media (max-width: 800px) {
        font-size: 1.1em;
      }
      @media (max-width: 640px) {
        flex-direction: column;
        .email-input {
          margin: 0 0 .3em 0 !important;
        }
      }


      .email-input {
        flex-basis: 70%;
        flex: 2;
        font-family: $font-family-primary;
        font-size: 1em;
        line-height: 1em;
        min-height: 2em;
        padding: 0 0.2em;
        border: 3px solid #b9b9b9 !important;
        border-radius: 0  !important;
        box-shadow: none !important;
        background: #fff;
        margin-right: .5em;
        &:focus {
          border-color: black;
          box-shadow: none !important;
        }
      }
      button {
        flex: 1;
        font-size: 1em;
        background-color: $main-bg;
        color: $dark-text-color;
        margin: 0;
        &:hover {
          background-color: #333;
          color: #fff;
        }
      }
    }
    .privacy-policy {
      font-size: .8em;
      margin: 0;
      color: #fff;
      align-self: flex-end;
      a {
        color: #ccc;
      }
    }
  }
}
</style>
